import React from 'react';

import { LoadableBackground } from '@confluence/loadable';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';

const ImpersonationFlagV2Loader = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ImpersonationFlag" */ './ImpersonationFlag'))
			.ImpersonationFlag,
});

const LazyImpersonationFlagComponent = () => <ImpersonationFlagV2Loader />;

export const LazyImpersonationFlag = withTransparentErrorBoundary({
	attribution: Attribution.PERMISSIONS_EXPERIENCE,
})(LazyImpersonationFlagComponent);
